exports = module.exports = require("../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "._1wMi9 {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  border-radius: 5px;\n  overflow: hidden;\n  width: 100%;\n  border: 1px solid #BD9471;\n}\n", ""]);

// Exports
exports.locals = {
	"tabs": "_1wMi9"
};